import React, { useEffect, useState } from "react";
import { getChequeById } from "../../api/chequesApi";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import { printChequeDetails } from "../../utils/printChequeDetails";

const ViewChequeModal = ({ chequeId, onClose }) => {
  const [cheque, setCheque] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCheque = async () => {
      try {
        const responseData = await getChequeById(chequeId);
        let chequeData = responseData?.cheque || responseData?.data || responseData;
        if (Array.isArray(chequeData)) chequeData = chequeData[0];
        setCheque(chequeData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (chequeId) fetchCheque();
  }, [chequeId]);

  const InfoRow = ({ label, value }) => (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "0.5rem 0", borderBottom: "1px solid #f1f5f9" }}>
      <span style={{ fontWeight: 600, color: "#64748b", fontSize: "0.875rem" }}>{label}</span>
      <span style={{ fontWeight: 500, color: "#1e293b", fontSize: "0.875rem", textAlign: "right" }}>{value || "—"}</span>
    </div>
  );

  return (
    <GlobalModal
      open={!!chequeId}
      onClose={onClose}
      title="Cheque Details"
      description={`Viewing record for cheque #${cheque?.cheque_no || chequeId}`}
      size="md"
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", width: "100%" }}>
          {cheque ? (
            <GlobalButton variant="ghost" onClick={() => printChequeDetails(cheque)}>
              Print details
            </GlobalButton>
          ) : null}
          <GlobalButton variant="ghost" onClick={onClose}>
            Close
          </GlobalButton>
        </div>
      }
    >
      {loading ? (
        <div style={{ padding: "2rem", textAlign: "center", color: "#64748b" }}>Loading cheque details...</div>
      ) : error ? (
        <div style={{ padding: "1rem", color: "var(--danger, #dc2626)" }}>{error}</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <div>
            <h3 style={{ fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--accent, #0ea5e9)", marginBottom: "0.5rem" }}>
              Section 1 — Cheque Info
            </h3>
            <InfoRow label="Issue code" value={cheque.cheque_issue_code} />
            <InfoRow label="Cheque type" value={cheque.type_name} />
            <InfoRow label="Cheque number" value={cheque.cheque_number || cheque.cheque_no} />
            <InfoRow label="Cheque date" value={cheque.cheque_date ? new Date(cheque.cheque_date).toLocaleDateString() : "—"} />
            <InfoRow label="Bank" value={cheque.bank_name} />
            <InfoRow label="Account number" value={cheque.account_number} />
            <InfoRow label="Amount" value={`₹${Number(cheque.amount).toLocaleString("en-IN")}`} />
            <InfoRow label="Purpose" value={cheque.purpose} />
          </div>

          <div>
            <h3 style={{ fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--accent, #0ea5e9)", marginBottom: "0.5rem" }}>
              People & verification
            </h3>
            <InfoRow label="Payee name" value={cheque.payee_name} />
            <InfoRow label="Voucher number" value={cheque.voucher_number || cheque.voucher_no} />
            <InfoRow label="Issued by" value={cheque.issued_by_name} />
            <InfoRow label="Authorized signatory" value={cheque.authorized_signatory_name} />
            <InfoRow label="Cheque status" value={cheque.status_name} />
            <InfoRow label="Cheque cleared" value={cheque.cheque_cleared ? "Yes" : "No"} />
            <InfoRow label="Clearance date" value={cheque.clearance_date ? new Date(cheque.clearance_date).toLocaleDateString() : "—"} />
            <InfoRow label="Remarks" value={cheque.remarks} />
            {cheque.signature_file_url ? (
              <InfoRow
                label="Signature"
                value={
                  <a href={cheque.signature_file_url} target="_blank" rel="noreferrer">
                    View file
                  </a>
                }
              />
            ) : null}
          </div>
        </div>
      )}
    </GlobalModal>
  );
};

export default ViewChequeModal;
